import { useState, useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from '../../components/shared/baseUrl.js';
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import {useSelector, useDispatch} from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';




const ctStepOptions = [
  "Decomposition",
  "Pattern Recognition",
  "Abstraction",
  "Algorithm Design"
];


const STANDARD_VAR_ALTS = ["total", "sum", "final", "result"];
const N_ALTS = ["n", "k", "i", "x", "y", "z"];
const OPERATOR_OPTIONS = [
  "+", "-", "*", "/", "%", "=", "==", "!=", "<", "<=", ">", ">=", "&&", "||", "+=", "-=", "*=", "/="
];
const PUNCTUATION_OPTIONS = ["(", ")", "{", "}", "[", "]"];
// Dynamic rendering of inputs




export default function ProStatement(props) {

  const [problem, setProblem] = useState('');
  const [selectedSteps, setSelectedSteps] = useState([]);
  const [response, setResponse] = useState(null);
  const [editedKG, setEditedKG] = useState({});
  const user = useSelector(state => state.user)
  const [existingProblemId, setExistingProblemId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { kgId } = useParams();
  const [steps, setSteps] = useState([]);
  const [showAddFormIndex, setShowAddFormIndex] = useState(null);
  const [newAltData, setNewAltData] = useState({});
  /////////code engine
  const [studentAnswer, setStudentAnswer] = useState({
    input: '',
    define: '',
    set: '',
    output: ''
  });
  const [executionOutput, setExecutionOutput] = useState("");
  const [selectedStatements, setSelectedStatements] = useState({
    define: "",
    set: "",
    output: ""
  });
  const [parsedAlgoParts, setParsedAlgoParts] = useState(null);
  const [generatedCode, setGeneratedCode] = useState("");
  const [selectedDefineVars, setSelectedDefineVars] = useState({});
  const [selectedOutputVars, setSelectedOutputVars] = useState({});



// Replace the extractDefinedVars function:
function extractDefinedVars(defineArray = []) {
  const vars = [];
  defineArray.forEach(d => {
    const stripped = d.replace(/^define\s*(var\s*)?/i, "").trim();
    const parts = stripped.split(",").map(part => {
      const name = part.split("=")[0].trim();
      return name;
    }).filter(name => name);
    vars.push(...parts);
  });
  return vars;
}

function tokenize(expr) {
  const tokenRegex = /<=|>=|==|!=|&&\|\||\+\+|--|\+=|-=|\*=|\/=|[+\-*/%<>=(){}\[\],;]|\d+(\.\d+)?|[A-Za-z_]\w*|\S/g;
  const tokens = [];
  let m;
  while ((m = tokenRegex.exec(expr)) !== null) {
    const t = m[0];
    let type = "other";
    if (/^[(){}\[\],;]$/.test(t)) type = "punct";
    else if (/^\d+(\.\d+)?$/.test(t)) type = "number";
    else if (/^[A-Za-z_]\w*$/.test(t)) {
      if (/^(while|for|if|else|switch|return|set)$/i.test(t)) type = "keyword";
      else type = "identifier";
    } else type = "operator";
    tokens.push({ raw: t, type });
  }
  return tokens;
}


/* Detect and build an editor object for the chosen set-statement.
   If the string looks like "set var = RHS" we treat "var" specially. Otherwise we tokenise whole statement. */


// buildSetEditorFromStatement function (updated for punctuation tokenization):
function buildSetEditorFromStatement(statement, definedVars, inputVars) {
  const rhs = statement.replace(/^set\s+\w+\s+to\s+/i, '');
  // Split on operators and punctuation, preserving them, and filter out empty tokens
  const tokens = rhs
    .split(/([\+\-\*\/\(\)\{\}\[\]])/)
    .filter(t => t.trim() && t !== '')
    .map(t => {
      if (/[\+\-\*\/]/.test(t)) return { raw: t, type: "operator" };
      if (/[0-9]/.test(t)) return { raw: t, type: "number" };
      if (/[\(\)\{\}\[\]]/.test(t)) return { raw: t, type: "punctuation" };
      return { raw: t, type: "identifier" };
    });
  const targetMatch = statement.match(/^set\s+(\w+)/i);
  console.log("buildSetEditorFromStatement - statement:", statement, "rhs:", rhs, "tokens:", tokens);
  return {
    original: statement,
    hasTarget: !!targetMatch,
    targetName: targetMatch ? targetMatch[1] : null,
    targetOptions: [...new Set([...definedVars, ...STANDARD_VAR_ALTS])],
    tokens,
    tokensSelected: Array(tokens.length).fill(""),
    targetSelected: ""
  };
}

/* Utility to read defined variable names from parsedAlgoParts.define
   (assumes forms like "define sum = 0" or "define x, y") */

function extractDefinedVars(defineArray = []) {
  const vars = [];
  defineArray.forEach(d => {
    const stripped = d.replace(/^define\b/i, "").trim();
    stripped.split(",").forEach(part => {
      const name = part.split("=")[0].trim();
      if (name) vars.push(name);
    });
  });
  return vars;
}

function renderDynamicInputs(inputDefs, studentAnswer, setStudentAnswer, parsedAlgoParts, setGeneratedCode, selectedDefineVars, selectedOutputVars) {
  return inputDefs.map((inp, idx) => {
    const matchArray = inp.match(/input\s+(\w+)\[(\d+)\]/i);
    const matchMultiple = inp.match(/input\s+(.+)/i);
    console.log(matchArray)
    console.log(matchMultiple)
    if (matchArray) {
      const varName = matchArray[1];
      const length = parseInt(matchArray[2], 10);
      return (
        <div key={idx} style={{ marginBottom: '8px' }}>
          <label>{varName}:</label>
          {Array.from({ length }).map((_, i) => (
            <select
              key={i}
              value={studentAnswer[`${varName}[${i}]`] || ""}
              onChange={(e) => {
                const newAns = { ...studentAnswer, [`${varName}[${i}]`]: Number(e.target.value) };
                setStudentAnswer(newAns);
                const result = generateCodeFromStructure(parsedAlgoParts, newAns, selectedDefineVars, selectedOutputVars || {});
                setGeneratedCode(result.code);
                console.log("Generated Code on Input Change:\n", result.code);
              }}
              style={{ margin: '0 4px' }}
            >
              <option value="">--Select--</option>
              {Array.from({ length: 100 }, (_, n) => n + 1).map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          ))}
        </div>
      );
    } else if (matchMultiple) {
      const vars = matchMultiple[1].split(",").map(v => v.trim());
      return vars.map((v, i) => (
        <div key={`${idx}-${i}`} style={{ marginBottom: '8px' }}>
          <label>{v}:</label>
          <select
            value={studentAnswer[v] || ""}
            onChange={(e) => {
              const newAns = { ...studentAnswer, [v]: Number(e.target.value) };
              setStudentAnswer(newAns);
              const result = generateCodeFromStructure(parsedAlgoParts, newAns, selectedDefineVars, selectedStatements.output || {});
              setGeneratedCode(result.code);
              console.log("Generated Code on Input Change:\n", result.code);
            }}
            style={{ marginLeft: '4px' }}
          >
            <option value="">--Select--</option>
            {Array.from({ length: 100 }, (_, n) => n + 1).map(num => (
              <option key={num} value={num}>{num}</option>
            ))}
          </select>
        </div>
      ));
    }
    return null;
  });
}

/* ---------- SetStatementEditor component ---------- */


function SetStatementEditor({ editor, onEditorChange, definedVars = [], inputVars = [], parsedAlgoParts, studentAnswer, setGeneratedCode, selectedDefineVars, selectedOutputVars }) {
  if (!editor) return null;

  const handleTokenChange = (idx, value) => {
    const sel = [...editor.tokensSelected];
    sel[idx] = value;
    const updatedEditor = { ...editor, tokensSelected: sel };
    onEditorChange(updatedEditor);
    const assembledTokens = [];
    let prevTokenType = null;
    let hasMeaningfulToken = false;
    editor.tokens.forEach((tok, tIdx) => {
      const selected = tIdx === idx ? value : (sel[tIdx] || "");
      if (selected && selected.trim()) {
        if (
          (prevTokenType === "identifier" || prevTokenType === "number") &&
          (tok.type === "identifier" || (tok.type === "punctuation" && selected === "("))
        ) {
          assembledTokens.push("*");
        }
        assembledTokens.push(selected);
        if (tok.type !== "punctuation" || PUNCTUATION_OPTIONS.includes(selected)) {
          hasMeaningfulToken = true;
        }
        prevTokenType = tok.type;
      }
    });
    const assembled = assembledTokens.join(" ");
    console.log("SetStatementEditor - tokensSelected:", sel, "assembled:", assembled, "hasMeaningfulToken:", hasMeaningfulToken);
    const tempParsedAlgoParts = {
      ...parsedAlgoParts,
      set: parsedAlgoParts.set.map((s, i) => i === editorIdx ? updatedEditor : s)
    };
    const result = generateCodeFromStructure(tempParsedAlgoParts, studentAnswer, selectedDefineVars, selectedOutputVars || {});
    setGeneratedCode(result.code);
    console.log("Generated Code on Token Change:\n", result.code);
  };

  const editorIdx = parsedAlgoParts.set.indexOf(editor);

  return (
    <div style={{ border: "1px solid #ddd", padding: 12, borderRadius: 6, marginBottom: 8 }}>
      {editor.hasTarget && (
        <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
          <strong>set</strong>
          <select
            value={editor.targetSelected || ""}
            onChange={(e) => {
              const updatedEditor = { ...editor, targetSelected: e.target.value };
              onEditorChange(updatedEditor);
              const tempParsedAlgoParts = {
                ...parsedAlgoParts,
                set: parsedAlgoParts.set.map((s, i) => i === editorIdx ? updatedEditor : s)
              };
              const result = generateCodeFromStructure(tempParsedAlgoParts, studentAnswer, selectedDefineVars, selectedOutputVars || {});
              setGeneratedCode(result.code);
              console.log("Generated Code on Target Change:\n", result.code);
            }}
          >
            <option value="">--select variable--</option>
            {[...new Set([...editor.targetOptions, ...STANDARD_VAR_ALTS])].map((v, i) => (
              <option key={i} value={v}>{v}</option>
            ))}
          </select>
          <span>=</span>
        </div>
      )}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {editor.tokens.map((tok, idx) => {
            console.log(tok)
          if (tok.type === "punctuation") {
            const opts = PUNCTUATION_OPTIONS;
            return (
              <select key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)}>
                <option value="">--punct--</option>
                {opts.map((o, i) => <option key={i} value={o}>{o}</option>)}
              </select>
            );
          }
          if (tok.type === "identifier") {
            const opts = Array.from(new Set([tok.raw, ...definedVars, ...inputVars, ...N_ALTS]));
            return (
              <select key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)}>
                <option value="">--var--</option>
                {opts.map((o, i) => <option key={i} value={o}>{o}</option>)}
              </select>
            );
          }
          if (tok.type === "number") {
            const opts = Array.from(new Set([tok.raw, ...Array.from({ length: 10 }, (_, i) => String(i + 1))]));
            return (
              <select key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)}>
                <option value="">--num--</option>
                {opts.map((o, i) => <option key={i} value={o}>{o}</option>)}
              </select>
            );
          }
          if (tok.type === "operator") {
            const opts = Array.from(new Set([tok.raw, ...OPERATOR_OPTIONS]));
            return (
              <select key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)}>
                <option value="">--op--</option>
                {opts.map((o, i) => <option key={i} value={o}>{o}</option>)}
              </select>
            );
          }
          if (tok.type === "keyword") {
            const opts = Array.from(new Set([tok.raw, "while", "for", "if", "else", "switch"]));
            return (
              <select key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)}>
                <option value="">--keyword--</option>
                {opts.map((o, i) => <option key={i} value={o}>{o}</option>)}
              </select>
            );
          }
          return <input key={idx} value={editor.tokensSelected[idx] || ""} onChange={(e) => handleTokenChange(idx, e.target.value)} />;
        })}
      </div>
    </div>
  );
}

/* Build input initialisation code from parsedAlgoParts.input and studentAnswer state */

function buildInputsCode(parsedAlgoParts, studentAnswer) {
  const code = [];
    console.log("buildInputsCode - studentAnswer:", studentAnswer);

  (parsedAlgoParts.input || []).forEach(inp => {
    const mArr = inp.match(/input\s+([A-Za-z_]\w*)\[(\d+)\]/i);
    const matchArray = inp.match(/input\s+(\w+)\[(\d+)\]/i);
    const matchMultiple = inp.match(/input\s+(.+)/i);
    console.log("buildInputsCode - inp:", inp, "matchArray:", matchArray, "matchMultiple:", matchMultiple);
    if (matchArray) {
      const varName = matchArray[1];
      const len = Number(mArr[2]);
      const length = parseInt(matchArray[2], 10);
      const values = Array.from({ length }, (_, i) => studentAnswer[`${varName}[${i}]`] || 0);
      code.push(`let ${varName} = [${values.join(", ")}];`);
    } else if (matchMultiple) {
      const vars = matchMultiple[1].split(",").map(v => v.trim());
      vars.forEach(v => {
        const value = studentAnswer[v] !== undefined ? studentAnswer[v] : 0;
        code.push(`let ${v} = ${value};`);
      });
    }
  });
  console.log("buildInputsCode - codeLines:", code);
  return code;
}

/* ---------- Code generation & run ---------- */

function generateCodeFromStructure(parsedAlgoParts, studentAnswer, selectedDefineVars, selectedOutputVars) {
  const codeLines = [];
  const errors = [];

  const safeSelectedOutputVars = selectedOutputVars || {};
  console.log("generateCodeFromStructure - parsedAlgoParts:", parsedAlgoParts);
  console.log("generateCodeFromStructure - studentAnswer:", studentAnswer);
  console.log("generateCodeFromStructure - selectedDefineVars:", selectedDefineVars);
  console.log("generateCodeFromStructure - selectedOutputVars:", safeSelectedOutputVars);

  // Inputs
  const inputCode = buildInputsCode(parsedAlgoParts, studentAnswer);
  codeLines.push(...inputCode);

  // Defines
  const define_map = {};
  (parsedAlgoParts.define || []).forEach((defStmt) => {
    const stripped = defStmt.replace(/^define\s*(var\s*)?/i, '').trim();
    stripped.split(',').forEach((part) => {
      const [name, ...init] = part.split('=');
      const initStr = init.length > 0 ? ' = ' + init.join('=').trim() : '';
      define_map[name.trim()] = initStr;
    });
  });

  const define_codes = [];
  Object.keys(selectedDefineVars || {}).forEach((original_var) => {
    const selected_var = selectedDefineVars[original_var];
    if (selected_var) {
      const init = define_map[original_var] || '';
      define_codes.push(`let ${selected_var}${init}`);
    }
  });

  if (define_codes.length > 0) {
    codeLines.push(define_codes.join(', ') + ';');
  }

  // Set Statements
  if (parsedAlgoParts.set?.length) {
    parsedAlgoParts.set.forEach((s, idx) => {
      let assembledTokens = [];
      let prevTokenType = null;
      let hasMeaningfulToken = false;
      s.tokens.forEach((tok, tIdx) => {
        const selected = s.tokensSelected[tIdx] || "";
        if (selected && selected.trim()) {
          if (
            (prevTokenType === "identifier" || prevTokenType === "number") &&
            (tok.type === "identifier" || (tok.type === "punctuation" && selected === "("))
          ) {
            assembledTokens.push("*");
          }
          assembledTokens.push(selected);
          if (tok.type !== "punctuation" || PUNCTUATION_OPTIONS.includes(selected)) {
            hasMeaningfulToken = true;
          }
          prevTokenType = tok.type;
        }
      });
      const assembled = assembledTokens.join(" ");
      console.log(`Set Statement ${idx + 1} - tokensSelected:`, s.tokensSelected, "assembled:", assembled, "hasMeaningfulToken:", hasMeaningfulToken);
      // Generate code if there’s at least one meaningful token (identifier, number, operator, or selected punctuation)
      if (assembled.trim() && hasMeaningfulToken) {
        if (s.hasTarget) {
          const tgt = s.targetSelected || s.targetName;
          codeLines.push(`${tgt} = ${assembled};`);
        } else {
          codeLines.push(assembled.endsWith(";") ? assembled : assembled + ";");
        }
      }
    });
  }

  // Outputs
  const vars = [];
  Object.keys(safeSelectedOutputVars).forEach((original_var) => {
    const selected_var = safeSelectedOutputVars[original_var];
    if (selected_var) {
      vars.push(selected_var);
    }
  });
  if (vars.length > 0) {
    const outputExpr = vars.join(" * ");
    const label = vars.join(", ");
    codeLines.push(`console.log("${label} =", ${outputExpr});`);
  } else {
    errors.push("No output variable selected");
  }

  const finalCode = codeLines.join("\n");
  console.log("generateCodeFromStructure - finalCode:", finalCode);
  return { success: true, code: finalCode, errors };
}



// Code runner

function runCodeInIframe(code, setExecutionOutput) {
  console.log("runCodeInIframe - code:", code);
  const iframe = document.getElementById("sandbox");
  if (!iframe) {
    console.log("runCodeInIframe - Sandbox iframe not found");
    setExecutionOutput("Sandbox iframe not found.");
    
    return;
  }
  const iframeWindow = iframe.contentWindow;
  const logs = [];
  const origConsole = iframeWindow.console;

   iframeWindow.console = {
    log: (...args) => {
      console.log("Iframe console.log:", ...args);
      logs.push(args.join(" "));
    },
    error: (...args) => {
      console.log("Iframe console.error:", ...args);
      logs.push("ERROR: " + args.join(" "));
    },
    warn: (...args) => {
      console.log("Iframe console.warn:", ...args);
      logs.push("WARN: " + args.join(" "));
    }
  };

  try {
    console.log("runCodeInIframe - Executing code");
    iframeWindow.eval(code);
    console.log("runCodeInIframe - Code executed successfully");
  } catch (err) {
    console.log("runCodeInIframe - Runtime error:", err.message);
    logs.push("Runtime error: " + err.message);
  } finally {
    iframeWindow.console = origConsole;
    setExecutionOutput(logs.join("\n"));
  }
}




 const fetchKG = async (pid, email) => {
    try{
      console.log('fetchKg called')
      
      //const pid = existingProblemId
      console.log(pid)
      //const email = user.email;
      console.log(email)
    let result = await axios.get(`${baseUrl}generate-kg/upload-kg/`, {
        params: { pid, email }
        });
    return result;
    
    }catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
        throw new Error("Cancelled");
      }
    }
  
  };
 

 useEffect(() => {
    console.log(kgId)
    if(kgId){
       try {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();       
      console.log(user)
      const email = user.email
      const pid = 'http://dbpedia.org/resource/'+kgId
      console.log('email- '+email)
      console.log('pid- '+pid)
      setExistingProblemId(pid)
      fetchKG(pid, email)
      .then((res) => {
        console.log('KG found:', res.data.kg);
        setEditedKG(res.data.kg);
        setResponse(res.data.kg);
        ///console.log(res.data.que)
        const usedCTSteps = Array.from(
          new Set(
            (res.data.kg || [])
              .map(step => step.step_name?.toLowerCase().trim())
              .filter(Boolean)
          )
        );
        setSteps(usedCTSteps)
        console.log(usedCTSteps)
        setProblem(res.data.que)
        setExistingProblemId(res.data.problemId);
        setIsEdit(true); // This enables Edit mode 
      })
      } 
        catch (err) {
          console.error('Error fetching KG:', err);
          setIsEdit(false);
        }
    }
    else{

    }
    
 }, [kgId, user.email])


 useEffect(() => {
    if (isEdit && editedKG.length > 0) {
      const algoStep = editedKG.find(step => step.step_name.toLowerCase().includes("algorithm_design"));
      if (algoStep?.solution) {
        const parsed = parseParts(algoStep.solution);
        setParsedAlgoParts(parsed);
      }
    }
  }, [editedKG, isEdit]);


const parseParts = (answer) => {
    const partsObj = { input: [], define: [], set: [], output: [] };
    const inputRegex = /^input\b/i;
    const defineRegex = /^define\b/i;
    const outputRegex = /^output\b/i;
    const setRegex = /^set\b/i;

    const parts = answer
      .split(/;(?![^{}]*\})/)
      .map(p => p.trim())
      .filter(Boolean);

    let defineBuffer = [];
    parts.forEach(p => {
      const lower = p.toLowerCase();
      if (inputRegex.test(lower)) {
        partsObj.input.push(p);
      } else if (defineRegex.test(lower)) {
        defineBuffer.push(p.replace(/^define\b\s*/i, '').trim());
      } else if (outputRegex.test(lower)) {
        partsObj.output.push(p);
      } else if (setRegex.test(lower) || /^while\b|^for\b|^if\b/i.test(lower)) {
        const definedVars = extractDefinedVars(partsObj.define || []);
        const inputVars = (partsObj.input || []).flatMap(inp => {
          const m = inp.match(/input\s+(.+)/i);
          return m ? m[1].split(",").map(s => s.trim().replace(/\[.*\]/, "")) : [];
        });
        console.log(p+' , '+definedVars+' , '+inputVars)
        const editor = buildSetEditorFromStatement(p, definedVars, inputVars);
        partsObj.set.push(editor);
      } else {
        const definedVars = extractDefinedVars(partsObj.define || []);
        const inputVars = (partsObj.input || []).flatMap(inp => {
          const m = inp.match(/input\s+(.+)/i);
          return m ? m[1].split(",").map(s => s.trim().replace(/\[.*\]/, "")) : [];
        });
        console.log(p)
        const editorObj = buildSetEditorFromStatement(p, definedVars, inputVars);
        partsObj.set.push(editorObj);
      }
    });

    if (defineBuffer.length > 0) {
      partsObj.define.push("define " + defineBuffer.join(", "));
    }

    Object.keys(partsObj).forEach(key => {
      if (key === "set") {
        const seen = new Set();
        partsObj[key] = partsObj[key].filter(s => {
          const orig = typeof s === "string" ? s : s.original;
          if (seen.has(orig)) return false;
          seen.add(orig);
          return true;
        });
      } else {
        partsObj[key] = [...new Set(partsObj[key])];
      }
    });

    return partsObj;
  };



  const handleStepChange = (e) => {
    const step = e.target.value;
    setSelectedSteps(prev =>
      prev.includes(step) ? prev.filter(s => s !== step) : [...prev, step]
    );
  };
  
    const handleSubmit = async (e) => {
    e.preventDefault();
    const confirmSave = window.confirm(`Do you want to generate a new Graph based on the problem statement`);
    if (!confirmSave) return;

    try {
      const res = await axios.post(`${baseUrl}generate-kg`, {
        problem,
        selectedSteps,
        autoSteps: selectedSteps.length === 0
      });
      const parsed = Array.isArray(res.data.kg) ? res.data.kg : JSON.parse(res.data.kg);
      setResponse(parsed);
      setEditedKG(parsed);
      const usedCTSteps = Array.from(
        new Set(
          (parsed || [])
            .map(step => step.step_name?.toLowerCase().trim())
            .filter(Boolean)
        )
      );
      setSteps(usedCTSteps);
    } catch (err) {
      console.error(err);
      alert("Error generating KG.");
    }
  };

    // Save edited KG to backend

  const handleSave = async () => {
   
     const confirmSave = window.confirm(`Are you sure you want to Save`);
    if (!confirmSave) return;

    const myId = 'http://dbpedia.org/resource/'+kgId
    console.log(myId)
   
    var edit= kgId ? true: false;
    console.log(edit)
    const email = user.email
    var payload = {};
    if(edit==true){
        payload = { email, problem, kg: editedKG, problemId: myId };
    }
    else{
        payload = { email, problem, kg: editedKG };
    }
    console.log(payload)
  try {
    const method = edit ? axios.put : axios.post;
    method(`${baseUrl}generate-kg/upload-kg`, payload)
    .then(res => {
      alert(res.data.message);
      setEditedKG(res.data.kg);
      setExistingProblemId(res.data.problemId)
      console.log(res.data.problemId)
      alert("Knowledge Graph saved successfully!");

    });
     
    } catch (err) {
      console.error(err);
      alert("Error saving KG.");
    }
  };

  /////updated Edited KG

   const handleEdit = (stepIndex, field, value) => {
    const updated = [...editedKG];
    updated[stepIndex][field] = value;
    setEditedKG(updated);
  };

  const handleEditHint = (stepIndex, hintIdx, field, value) => {
    const updated = [...editedKG];
    updated[stepIndex].hintGenerate[hintIdx][field] = value;
    setEditedKG(updated);
  };


////handle student forms

const handleStepEdit = (stepIdx, field, value) => {
  const updated = [...editedKG];
  updated[stepIdx][field] = value;
  setEditedKG(updated);
};

const addOption = (stepIdx) => {
  const updated = [...editedKG];
  if (!updated[stepIdx].options) updated[stepIdx].options = [];
  updated[stepIdx].options.push('');
  setEditedKG(updated);
};

const handleOptionEdit = (stepIdx, optIdx, value) => {
  const updated = [...editedKG];
  updated[stepIdx].options[optIdx] = value;
  setEditedKG(updated);
};

const removeOption = (stepIdx, optIdx) => {
  const updated = [...editedKG];
  updated[stepIdx].options.splice(optIdx, 1);
  setEditedKG(updated);
};

const handleInputStructureEdit = (stepIdx, field, value) => {
  const updated = [...editedKG];
  if (!updated[stepIdx].inputStructure) updated[stepIdx].inputStructure = {};
  updated[stepIdx].inputStructure[field] = value;
  setEditedKG(updated);
};



  
  return (
   <>
   {kgId==null?
      <h2>Teacher: Generate Knowledge Graph for CT Problem</h2>:<h2>Problem statement: {problem}</h2>}
      {kgId==null ? 
        <form onSubmit={handleSubmit}>
          <label><strong>CT Problem Statement:</strong></label>
          <textarea
            value={problem}
            onChange={(e) => setProblem(e.target.value)}
            rows={5}
            style={{ width: '100%', marginBottom: '1rem' }}
            placeholder="e.g., Write an algorithm to calculate the sum from 1 to n..."
            required
          />

          <label><strong>Select CT Steps:</strong></label>
          <div style={{ marginBottom: '1rem' }}>
            {ctStepOptions.map(step => (
              <label key={step} style={{ marginRight: '1rem' }}>
                <input
                  type="checkbox"
                  value={step}
                  checked={selectedSteps.includes(step)}
                  onChange={handleStepChange}
                />
                {step}
              </label>
            ))}
        </div>

        <button type="submit">Generate Knowledge Graph</button>
      </form>:null}

      {/* Display KG and Student Interface */}
      
     {response && Array.isArray(editedKG) && (
    isEdit? (<GridContainer>
    <GridItem xs={12} sm={12} md={6}>
            <h3>Knowledge Graph Editor</h3>
            <h4 style={{ borderBottom: '2px solid #444' }}>Optimal Solutions</h4>
            {editedKG.map((step, index) => (
              <div key={`opt-${index}`} style={{ marginBottom: '1.5rem' }}>
                <h5>{step.step_name}</h5>
                <button
                  onClick={() => {
                    const confirmDelete = window.confirm(`Are you sure you want to delete the step "${step.step_name}"?`);
                    if (!confirmDelete) return;
                    const updatedKG = [...editedKG];
                    updatedKG.splice(index, 1);
                    setEditedKG(updatedKG);
                  }}
                  style={{
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '4px 8px',
                    cursor: 'pointer'
                  }}
                  title="Delete this step"
                >
                  🗑️
                </button>
                <label>Task:</label>
                <textarea
                  value={step.task}
                  onChange={(e) => handleEdit(index, 'task', e.target.value)}
                  rows={2}
                  style={{ width: '100%' }}
                />
                <label>Optimal Solution:</label>
                <textarea
                  value={step.solution}
                  onChange={(e) => handleEdit(index, 'solution', e.target.value)}
                  rows={2}
                  style={{ width: '100%' }}
                />
                <label>No-Match Prompt:</label>
                <input
                  type="text"
                  value={step.hintnotMatched?.prompt || ''}
                  onChange={(e) => handleEdit(index, 'hintnotMatched', {
                    ...step.hintnotMatched,
                    prompt: e.target.value
                  })}
                  style={{ width: '100%' }}
                />
                <label>Basic Hint:</label>
                <input
                  type="text"
                  value={step.hintnotMatched?.basicHint || ''}
                  onChange={(e) => handleEdit(index, 'hintnotMatched', {
                    ...step.hintnotMatched,
                    basicHint: e.target.value
                  })}
                  style={{ width: '100%' }}
                />
                <label>Intermediate Hint:</label>
                <input
                  type="text"
                  value={step.hintnotMatched?.intermediateHint || ''}
                  onChange={(e) => handleEdit(index, 'hintnotMatched', {
                    ...step.hintnotMatched,
                    intermediateHint: e.target.value
                  })}
                  style={{ width: '100%' }}
                />
              </div>
            ))}
            <h4 style={{ borderBottom: '2px solid #444', marginTop: '2rem' }}>Non-Optimal Alternatives</h4>
            {['decomposition', 'pattern', 'abstraction', 'algorithm_design', 'analysis'].map((stepName, index) => {
              const stepIndex = editedKG.findIndex(s => s.step_name.toLowerCase() === stepName.toLowerCase());
              if (stepIndex === -1) return null;
              const step = editedKG[stepIndex];
              const correctAlts = (step.hintGenerate || []).filter(h => h.answerType === 'correct');
              const incorrectAlts = (step.hintGenerate || []).filter(h => h.answerType !== 'correct');

              return (
                <div key={`nonopt-${index}`} style={{ marginBottom: '2rem', padding: '1rem', background: '#f9f9f9', borderRadius: '6px' }}>
                  <h5>Step {index + 1}: {step.step_name}</h5>
                  <h5 style={{ marginTop: '1rem' }}>Correct Alternate Answers:</h5>
                  {showAddFormIndex === stepIndex && (
                    <div style={{ marginTop: '1rem', padding: '1rem', border: '1px dashed gray', borderRadius: '4px' }}>
                      <h6>➕ Add New Alternate Correct Solution</h6>
                      {steps.slice(steps.indexOf(step.step_name)).map((s, idx) => (
                        <div key={idx} style={{ marginBottom: '0.5rem' }}>
                          <label>{s.charAt(0).toUpperCase() + s.slice(1)}:</label>
                          <input
                            type="text"
                            value={newAltData[s] || ''}
                            onChange={(e) => setNewAltData({ ...newAltData, [s]: e.target.value })}
                            style={{ width: '100%' }}
                          />
                        </div>
                      ))}
                      <label>Alt Hint:</label>
                      <input
                        type="text"
                        value={newAltData.altHint || ''}
                        onChange={(e) => setNewAltData({ ...newAltData, altHint: e.target.value })}
                        style={{ width: '100%' }}
                      />
                      <label>Prompt:</label>
                      <input
                        type="text"
                        value={newAltData.prompt || ''}
                        onChange={(e) => setNewAltData({ ...newAltData, prompt: e.target.value })}
                        style={{ width: '100%' }}
                      />
                      <label>Basic Hint:</label>
                      <input
                        type="text"
                        value={newAltData.basicHint || ''}
                        onChange={(e) => setNewAltData({ ...newAltData, basicHint: e.target.value })}
                        style={{ width: '100%' }}
                      />
                      <label>Intermediate Hint:</label>
                      <input
                        type="text"
                        value={newAltData.intermediateHint || ''}
                        onChange={(e) => setNewAltData({ ...newAltData, intermediateHint: e.target.value })}
                        style={{ width: '100%' }}
                      />
                      <button
                        onClick={() => {
                          const altAnswer = steps.slice(steps.indexOf(step.step_name))
                            .map(s => newAltData[s] || '')
                            .join(' ~ ');
                          const newHint = {
                            altAnswer,
                            altHint: newAltData.altHint,
                            prompt: newAltData.prompt,
                            basicHint: newAltData.basicHint,
                            intermediateHint: newAltData.intermediateHint,
                            answerType: 'correct'
                          };
                          const updated = [...editedKG];
                          updated[stepIndex].hintGenerate = [...(updated[stepIndex].hintGenerate || []), newHint];
                          setEditedKG(updated);
                          setShowAddFormIndex(null);
                          setNewAltData({});
                        }}
                        style={{
                          marginTop: '1rem',
                          background: 'blue',
                          color: 'white',
                          padding: '6px 12px',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        Save Alternate Solution
                      </button>
                      <button
                        onClick={() => {
                          setShowAddFormIndex(null);
                          setNewAltData({});
                        }}
                        style={{
                          marginTop: '1rem',
                          background: 'gray',
                          color: 'white',
                          padding: '6px 12px',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                  {correctAlts.map((hintObj, hintIdx) => {
                    const parts = hintObj.altAnswer.split('~').map(p => p.trim());
                    const currentIndex = steps.indexOf(step.step_name);
                    const alignedSteps = steps.slice(currentIndex);
                    const reversedSteps = [...alignedSteps].reverse();
                    const reversedParts = [...parts].reverse();
                    const mysol = reversedSteps.map((stepName, idx) => ({
                      label: stepName,
                      value: reversedParts[idx] || ""
                    })).reverse();

                    const handleDelete = () => {
                      const preview = mysol.map(item => `${item.label}: ${item.value}`).join('\n');
                      const confirmDelete = window.confirm(
                        `Are you sure you want to delete this alternate solution?\n\n${preview}\n\nHint:\nAlt Hint: ${hintObj.altHint}\nPrompt: ${hintObj.prompt}\nBasic Hint: ${hintObj.basicHint}\nIntermediate Hint: ${hintObj.intermediateHint}`
                      );
                      if (!confirmDelete) return;
                      const updatedKG = [...editedKG];
                      const newHints = [...updatedKG[stepIndex].hintGenerate];
                      newHints.splice(hintIdx, 1);
                      updatedKG[stepIndex].hintGenerate = newHints;
                      setEditedKG(updatedKG);
                    };

                    return (
                      <div key={`correct-${hintIdx}`} style={{ padding: '0.5rem', borderBottom: '1px dashed #aaa' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <strong>Solution {hintIdx + 1} (Editable Alternate Solution):</strong>
                          <button
                            onClick={handleDelete}
                            style={{
                              background: 'red',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '2px 6px',
                              cursor: 'pointer'
                            }}
                            title="Delete this alternate solution"
                          >
                            ❌
                          </button>
                          <button
                            onClick={() => {
                              const currentIndex = steps.indexOf(step.step_name);
                              const aligned = steps.slice(currentIndex);
                              const initData = {};
                              aligned.forEach(s => (initData[s] = ''));
                              setNewAltData({ ...initData, altHint: '', prompt: '', basicHint: '', intermediateHint: '' });
                              setShowAddFormIndex(stepIndex);
                            }}
                            style={{
                              background: 'green',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '2px 6px',
                              cursor: 'pointer'
                            }}
                            title="Add new alternate solution"
                          >
                            ➕
                          </button>
                        </div>
                        {mysol.map((item, i) => (
                          <div key={i} style={{ marginBottom: '0.5rem' }}>
                            <label>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}:</label>
                            <input
                              type="text"
                              value={item.value}
                              onChange={(e) => {
                                const updatedMysol = [...mysol];
                                updatedMysol[i].value = e.target.value;
                                const newAltAnswer = updatedMysol.map(p => p.value).join('~');
                                const updatedKG = [...editedKG];
                                updatedKG[stepIndex].hintGenerate[hintIdx].altAnswer = newAltAnswer;
                                setEditedKG(updatedKG);
                              }}
                              style={{ width: '100%' }}
                            />
                          </div>
                        ))}
                        <label>Alt Hint:</label>
                        <input
                          type="text"
                          value={hintObj.altHint}
                          onChange={(e) => handleEditHint(stepIndex, hintIdx, 'altHint', e.target.value)}
                          style={{ width: '100%' }}
                        />
                        <label>Prompt:</label>
                        <input
                          type="text"
                          value={hintObj.prompt}
                          onChange={(e) => handleEditHint(stepIndex, hintIdx, 'prompt', e.target.value)}
                          style={{ width: '100%' }}
                        />
                        <label>Basic Hint:</label>
                        <input
                          type="text"
                          value={hintObj.basicHint}
                          onChange={(e) => handleEditHint(stepIndex, hintIdx, 'basicHint', e.target.value)}
                          style={{ width: '100%' }}
                        />
                        <label>Intermediate Hint:</label>
                        <input
                          type="text"
                          value={hintObj.intermediateHint}
                          onChange={(e) => handleEditHint(stepIndex, hintIdx, 'intermediateHint', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                    );
                  })}
                  {incorrectAlts.length > 0 && (
                    <>
                      <h5 style={{ marginTop: '1rem' }}>Incorrect Alternatives</h5>
                      {incorrectAlts.map((hintObj, hintIdx) => (
                        <div key={`incorrect-${hintIdx}`} style={{ padding: '0.5rem', background: '#ffeaea', borderBottom: '1px dashed #aaa' }}>
                          <label>Alt Answer:</label>
                          <input
                            type="text"
                            value={hintObj.altAnswer}
                            onChange={(e) => handleEditHint(stepIndex, hintIdx, 'altAnswer', e.target.value)}
                            style={{ width: '100%' }}
                          />
                          <label>Alt Hint:</label>
                          <input
                            type="text"
                            value={hintObj.altHint}
                            onChange={(e) => handleEditHint(stepIndex, hintIdx, 'altHint', e.target.value)}
                            style={{ width: '100%' }}
                          />
                          <label>Prompt:</label>
                          <input
                            type="text"
                            value={hintObj.prompt}
                            onChange={(e) => handleEditHint(stepIndex, hintIdx, 'prompt', e.target.value)}
                            style={{ width: '100%' }}
                          />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              );
            })}
            <button onClick={handleSave} style={{ marginTop: '1rem' }}>Save KG to MongoDB</button>
          </GridItem>

    {/* Right: Student Simulation */}
    <GridItem xs={12} sm={12} md={6}>
            <h3>Simulated Student Interface</h3>
            {editedKG.map((step, index) => {
              const isAlgoStep = step.step_name.toLowerCase().includes("algorithm_design");
              return (
                <div key={index} style={{ marginBottom: '1rem', borderBottom: '1px dashed #aaa' }}>
                  <h4>{step.step_name}</h4>
                  <label>Student Input Type:</label>
                  <select
                    value={step.uiType}
                    onChange={(e) => handleStepEdit(index, 'uiType', e.target.value)}
                  >
                    <option value="multiple-choice">Multiple Choice</option>
                    <option value="structured-form">Structured Form</option>
                    <option value="text-input">Free Text</option>
                  </select>
                  <p><strong>Task:</strong> {step.task}</p>
                  <p>Provide your answer below-</p>
                  
                  {isAlgoStep && parsedAlgoParts && (
                    <>
                      <h5>Algorithm Builder</h5>
                      <iframe id="sandbox" style={{ display: 'none' }} title="sandbox"></iframe>
                      <div>
                        <label>Input Statement(s):</label>
                        {renderDynamicInputs(parsedAlgoParts.input || [], studentAnswer, setStudentAnswer, parsedAlgoParts, setGeneratedCode, selectedDefineVars, selectedOutputVars)}
                      </div>
                     <div style={{ marginTop: 12 }}>
                        <label>Define Variable(s):</label>
                        {(parsedAlgoParts.define || []).flatMap((defStmt, defIdx) => {
                          const vars = defStmt.replace(/^define\s*(var\s*)?/i, "").split(",").map(v => v.split("=")[0].trim()).filter(v => v);
                          return vars.map((varName, varIdx) => (
                            <div key={`${defIdx}-${varIdx}`} style={{ marginBottom: '8px' }}>
                              <select
                                value={selectedDefineVars[varName] || ""}
                                onChange={(e) => {
                                  const newSelectedDefineVars = { ...selectedDefineVars, [varName]: e.target.value };
                                  setSelectedDefineVars(newSelectedDefineVars);
                                  console.log(selectedDefineVars)
                                  const result = generateCodeFromStructure(parsedAlgoParts, studentAnswer, newSelectedDefineVars, selectedOutputVars || {});
                                  setGeneratedCode(result.code);
                                  console.log("Generated Code on Define Change:\n", result.code);
                                }}
                              >
                                <option value="">--select variable--</option>
                                {[...new Set([varName, ...STANDARD_VAR_ALTS])].map((v, i) => (
                                  <option key={i} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                          ));
                        })}
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <label>Set Statements:</label>
                        {(parsedAlgoParts.set || []).map((editor, idx) => (
                          <div key={idx} style={{ marginTop: "8px" }}>
                            <SetStatementEditor
                              editor={editor}
                              definedVars={extractDefinedVars(parsedAlgoParts.define || [])}
                              inputVars={(parsedAlgoParts.input || []).flatMap(inp => {
                                const m = inp.match(/input\s+(.+)/i);
                                return m ? m[1].split(",").map(s => s.trim().replace(/\[.*\]/, "")) : [];
                              })}
                              parsedAlgoParts={parsedAlgoParts}
                              studentAnswer={studentAnswer}
                              setGeneratedCode={setGeneratedCode}
                              selectedDefineVars={selectedDefineVars}
                              selectedOutputVars={selectedOutputVars}
                              onEditorChange={(updatedEditor) => {
                                setParsedAlgoParts(prev => {
                                  const newSetParts = [...prev.set];
                                  newSetParts[idx] = updatedEditor;
                                  const updatedParts = { ...prev, set: newSetParts };
                                  const result = generateCodeFromStructure(updatedParts, studentAnswer, selectedDefineVars, selectedOutputVars);
                                  setGeneratedCode(result.code);
                                  console.log("Generated Code on Set Statement Change:\n", result.code);
                                  return updatedParts;
                                });
                              }}
                            />
                          </div>
                        ))}
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <label>Output Variable(s):</label>
                        {(parsedAlgoParts.output || []).flatMap((outStmt, outIdx) => {
                          const vars = outStmt.replace(/^output\s+/i, "").split(",").map(v => v.trim());
                          return vars.map((varName, varIdx) => (
                            <div key={`${outIdx}-${varIdx}`} style={{ marginBottom: '8px' }}>
                              <select
                                value={selectedOutputVars[varName] || ""}
                                onChange={(e) => {
                                  const newSelectedOutputVars = { ...selectedOutputVars, [varName]: e.target.value };
                                  setSelectedOutputVars(newSelectedOutputVars);
                                  const result = generateCodeFromStructure(parsedAlgoParts, studentAnswer, selectedDefineVars, newSelectedOutputVars);
                                  setGeneratedCode(result.code);
                                  console.log("Generated Code on Output Change:\n", result.code);
                                }}
                              >
                                <option value="">--select variable--</option>
                                {[...new Set([varName, ...STANDARD_VAR_ALTS])].map((v, i) => (
                                  <option key={i} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                          ));
                        })}
                      </div>
                      <div style={{ marginTop: 12 }}>
                        <button onClick={() => {
                          const result = generateCodeFromStructure(parsedAlgoParts, studentAnswer, selectedDefineVars, selectedOutputVars);
                          setGeneratedCode(result.code);
                          console.log("Generated Code on Run:\n", result.code);
                          if (!result.success) {
                            alert("Please fix the following errors:\n" + result.errors.join("\n"));
                          } else {
                            runCodeInIframe(result.code, setExecutionOutput);
                          }
                        }}>
                          ▶️ Run Algorithm
                        </button>
                      </div>
                      <div style={{ marginTop: 12, background: "#f0f0f0", padding: 8, borderRadius: 4 }}>
                        <strong>Generated Code:</strong>
                        <pre>{generatedCode || "// Select statements to generate code"}</pre>
                      </div>
                      {executionOutput && (
                        <div style={{ marginTop: 12, background: "#f6f6f6", padding: 8 }}>
                          <strong>Execution Output:</strong>
                          <pre>{executionOutput}</pre>
                        </div>
                      )}
                    </>
                  )}
                  {!isAlgoStep && (
                    <select>
                      <option value="">--Select Operation--</option>
                      {(step.hintGenerate || []).map((opt, i) => (
                        <option key={i} value={opt.altAnswer}>{opt.altAnswer}</option>
                      ))}
                      <option value={step.solution}>{step.solution}</option>
                    </select>
                  )}
                  {step.uiType === 'multiple-choice' && (
                    <>
                      <label>Options:</label>
                      {step.options?.map((opt, optIdx) => (
                        <div key={optIdx}>
                          <input
                            value={opt}
                            onChange={(e) => handleOptionEdit(index, optIdx, e.target.value)}
                          />
                          <button onClick={() => removeOption(index, optIdx)}>❌</button>
                        </div>
                      ))}
                      <button onClick={() => addOption(index)}>Add Option</button>
                    </>
                  )}
                  {step.uiType === 'structured-form' && (
                    <>
                      {['input', 'define', 'set', 'output'].map(field => (
                        <div key={field}>
                          <label>{field.charAt(0).toUpperCase() + field.slice(1)}:</label>
                          <input
                            value={step.inputStructure?.[field] || ""}
                            onChange={(e) =>
                              handleInputStructureEdit(index, field, e.target.value)
                            }
                          />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              );
            })}
          </GridItem>
  </GridContainer>) :null
)}
    </>
  );
}